import { render } from "./InnovationsByEntityChart.vue?vue&type=template&id=0ca42f5e"
import script from "./InnovationsByEntityChart.vue?vue&type=script&lang=js"
export * from "./InnovationsByEntityChart.vue?vue&type=script&lang=js"
script.render = render

export default script